<script setup>
import useCharts from "@/composables/useCharts";

const props = defineProps({
  series: {
    required: true,
    type: Array,
  },
  height: {
    required: false,
    default: '400px',
    type: String,
  },
});

const {chartRef} = useCharts(props.series);
</script>

<template>
  <apexchart
    ref="chartRef"
    :height="height"
    :series="series"
  />
</template>

<style>
.apexcharts-toolbar {
  max-width: unset !important;
  top: -5rem !important;
  left: unset !important;
  right: -2rem !important;
}

.apexcharts-reset-icon {
  margin-left: 0 !important;
}

.apexcharts-toolbar > div{
  width: 40px;
  height: 40px;
  transform: scale(1);
  margin-right: 6px;
}

.apexcharts-menu {
  height: unset !important;
  margin-right: 0;
  right: 14px !important;
  width: unset !important;
}

.apexcharts-menu-item {
  padding: .6rem .75rem;
  text-align: center;
}

.apexcharts-xaxis-label, .apexcharts-yaxis-label {
  fill: #999999;
}

.apexcharts-legend {
  gap: 1rem;
}

.apexcharts-legend-series {
  display: flex !important;
}

.apexcharts-legend-marker {
  display: flex !important;
}

.apexcharts-legend-text {
  color: #999999 !important;
  font-family: inherit !important;
  font-size: 1rem !important;
}

.apexcharts-bar-chart .apex-custom-tooltip {
  position: relative;
  padding: .5rem 1.5rem;
  border: none;
}

.apexcharts-bar-chart .apex-custom-tooltip:before, .apexcharts-bar-chart .apex-custom-tooltip:after {
  right: 35%;
  top: -25%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.apexcharts-bar-chart .apex-custom-tooltip:before {
  border-right-color: #003C66;
  border-width: 13px;
  margin-top: -13px;
  transform: rotate(90deg);
}

.vue-apexcharts .apexcharts-tooltip {
  color: #fff;
  transform: translateX(-100%) translateY(175%);
  overflow: visible !important;
  white-space: normal !important;
  border: none !important;
  background: #003C66 !important;
  border-radius: 6px;
}

.line-chart .apexcharts-tooltip {
  transform: translateX(0%) translateY(100%);
  padding: 1rem;
}

.vue-apexcharts .apexcharts-tooltip-title {
  color: #fff;
  border-radius: 6px;
  border: none !important;
  font-weight: 700;
  background: #003C66 !important;
}

.apexcharts-bar-chart .apexcharts-tooltip span {
  padding: 5px 10px;
  display: inline-block;
}
</style>